import React from "react";
import { useTranslation } from "react-i18next";
import { Sector } from "../../../types/modules/admin/sector.type";
import SectorItem from "./SectorItem";
import { PermissionGate } from "../PermissionGate";
import { PermissionsKey } from "../../../data/permissions";

interface Props {
  sectors: Sector[];
}

const SectorListTable: React.FC<Props> = ({ sectors }) => {
  const { t } = useTranslation();

  return (
    <div className="overflow-x-auto">
      <table className="w-full border-separate border-spacing-y-5">
        <thead>
          <tr className="text-start text-sm text-DarkGrey2 font-semibold">
            <th className="p-3 font-normal capitalize">{t("id")}</th>
            <th className="p-3 font-normal capitalize">{t("name_in_english")}</th>
            <th className="p-3 font-normal capitalize">{t("name_in_arabic")}</th>
            <PermissionGate permissions={[PermissionsKey.UpdateSector]}>
              <th className="p-3 font-normal capitalize">{t("actions")}</th>
            </PermissionGate>
          </tr>
        </thead>
        <tbody className="text-sm">
          {sectors.map((sector, index) => (
            <tr
              key={sector.id}
              className="bg-white rounded-[12px]"
              style={{ boxShadow: "0px 4px 32px rgba(86, 92, 120, 0.08)" }}
            >
                <SectorItem sector={sector}/>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
export default SectorListTable;